import React, { useEffect, useState } from 'react'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { messageExtendSuccessPayment, messageSuccessPayment } from '../../utils/helper'
import { errorMessage } from '../../constants/errorMessage'
import { Circles } from 'react-loader-spinner'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import { connect } from 'react-redux'
import NoData from '../NoData'

const mobileGooglePayDC = (props) => {
    const {dispatch, notify, setThankYouMessage, setResponse, data, page, setPage, setDisplayError, setErrorMessage, displayError, failedMessage} = props
    // const [isRendered, setIsRendered] = useState(true)
    const [divChilds, setDivChilds] = useState(0)
    const [ispaymentLoading, setIsPaymentLoading] = useState(false)
    

    useEffect(() => {
        setPage(0)
    },[])

    useEffect(() => {
        const restrictedDiv = document.getElementById('google-pay-button')
        const childCount = restrictedDiv?.children?.length
        setDivChilds(childCount == 0 ? 1 : childCount)
    })

    useEffect(() => {
        function ensureSingleChild(div, newChild) {
            
            // If the div has more than one child, remove all but the last one
            while (div?.children?.length > 1) {
                div.removeChild(div?.firstElementChild)
            }
            // If the div has no children, simply append the new child
            if (div?.children?.length === 0) {
                div?.appendChild(newChild)
            } else {
                // Otherwise, replace the current child with the new child
                div?.replaceChild(newChild, div.firstElementChild)
            }
        }
        const restrictedDiv = document.getElementById('google-pay-button')
        // Example: Adding new content
        const newElement = document.createElement('p')
        // newElement.textContent = 'This is the new single child content.'
        // Call the function to ensure there's only one child in the div
        ensureSingleChild(restrictedDiv, newElement)
        return () => {
            // console.log('')
        }
         
    },[EMPTY_ARRAY, divChilds, ispaymentLoading])
    
    useEffect(() => {
        if(data){
            setDisplayError(false)
            setErrorMessage('')
            const payload = {
                token: data?.wallet_datacap_token,
                mid: data?.wallet_datacap_mid,
                merchant: data?.wallet_datacap_gpay_merchant,
                amount: JSON.parse(data?.request || '{}')?.total ? Number(JSON.parse(data?.request || '{}')?.total).toFixed(2) : 0,
                requestData: data
            }
            if (
                payload?.token &&
                payload?.mid &&
                payload?.merchant &&
                payload?.amount && 
                divChilds == 1 && 
                document.getElementById('google-pay-button')
            ){
                try{  
                new Promise(() => window.DatacapGooglePay.init(
                        getToken(payload),
                        payload?.token,
                        payload?.mid,
                        payload?.merchant,
                        Number(payload?.amount)?.toFixed(2)
                ))  
                } catch (error) {
                    // Add an Event Log
                    let errObject = {
                        payload: payload,
                        errorMessage: error
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} gettoken Promosie tokenizeAPi-mobileGooglePayDC.js-83`))
                    notify('error', errorMessage?.somethingWentWrong)
                }
            }
        }else{
            setErrorMessage(errorMessage?.errorinParams)
            setDisplayError(true)
        }
        
        
    }, [EMPTY_ARRAY, divChilds])

   
    let googlePayWindow
    let intervalId

    const onGooglePayLoaded = () => {
        const originalOpen = window.open
        window.open = function(url, name, specs) {
            const newWindow = originalOpen(url, name, specs)
            if (url.startsWith('https://pay.google.com/')) {
                googlePayWindow = newWindow
                // Call API for Storing Logs
                monitorWindowClosed()
            }
            return newWindow
        }
    }

    const monitorWindowClosed = () => {
        intervalId = setInterval(() => {
            if (googlePayWindow && googlePayWindow.closed) {
                // Call API for Storing Logs
                clearInterval(intervalId)
            }
        }, 500)
    }

    document.addEventListener('DOMContentLoaded', () => {
        // Ensure onGooglePayLoaded is called after the Google Pay script is loaded
    })
    
    const submitResponseOnServer = (responseData) => {
        var headers = {}
        headers['Content-Type'] = 'application/json'
        headers['Authorization'] = responseData?.Authorization
        headers['X-ClientSecret'] = responseData?.['X-ClientSecret']
        headers['User-Agent'] = 'AwesomePOS/1.2.3'

        const request = responseData?.request
        setIsPaymentLoading(true)
        // document.getElementById('payload').innerHTML = 'Please wait...'     
        request.paymentMethods = 'GPAY'
        if(responseData?.api_url.includes('extend')){
          request['pave-make-extend-payment'] = 1
        }
        if(responseData?.api_url.includes('ungated-checkin-payment')){
          request['pave-make-web-ungated-checkin-payment'] = 1
        }
        
        
        fetch(responseData?.api_url, {
            method: 'POST',
            body: JSON.stringify(request),
            headers: headers,
        }).then(function (payApiResponse) {
            
            payApiResponse.json().then(function (json) {
                setIsPaymentLoading(false)
                const apiResponse = json
                
                setResponse(apiResponse)
                if(apiResponse?.data && apiResponse?.data != ''){
                    let errObject = {
                        payload: request,
                        errorMessage: apiResponse,
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_SUCCESS} ${responseData?.api_url} response json parse`))
                    if(responseData?.api_url.includes('extend')){
                        setThankYouMessage(messageExtendSuccessPayment)
                    }else{
                        setThankYouMessage(messageSuccessPayment)
                    }
                    setErrorMessage('')
                    setPage(1)
                }else {
                    let errObject = {
                        payload: request,
                        errorMessage: apiResponse,
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_FAILURE} ${responseData?.api_url} response json parse`))
                    setErrorMessage(apiResponse?.errors?.message ? apiResponse?.errors?.message : errorMessage?.somethingWentWrong)
                    setPage(2)
                }
            }).catch((err) => {
                setIsPaymentLoading(false)
                setPage(2)
                setResponse(err)
                let errObject = {
                    payload: request,
                    errorMessage: err,
                }
                setErrorMessage(err ? err : errorMessage?.somethingWentWrong)
                dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_FAILURE} ${responseData?.api_url}`))
            })
        }).catch((err) => {
            setIsPaymentLoading(false)
            setPage(2)
            setResponse(err)
            let errObject = {
                payload: request,
                errorMessage: err,
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_FAILURE} ${responseData?.api_url}`))
            setErrorMessage(err ? err : errorMessage?.somethingWentWrong)
        })
    }

    const getToken = (paymentData) => {
        onGooglePayLoaded()
        // Tokenization Callback
        const tokenCallback = function (tokenResponse) {
          return new Promise(function (resolve, reject) {
            // If error, show error
            if (tokenResponse.Message) {
                notify('error', 'Token Error: ' + tokenResponse.Message)
                let errObject = {
                    payload: paymentData,
                    errorMessage: tokenResponse.Message
                }
                dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} tokenError tokenizeAPi-mobileGooglePayDC.js-185`))
            //   return
            }else{
                // If good, call Pay API
                const paydiv = document.getElementById('gpay-button-online-api-id')
                paydiv.remove()
                setIsPaymentLoading(true)
                var token = tokenResponse.Token
                var headers = {}
                headers['Content-Type'] = 'application/json'
                headers['Authorization'] = paymentData?.mid
                headers['User-Agent'] = 'AwesomePOS/1.2.3'
                var payApiRequest = [
                {
                    Amount: paymentData?.amount
                    ? Number(paymentData?.amount)?.toFixed(2)
                    : 0.0,
                    Token: token,
                },
                ]
                if(paymentData?.mid && token){
                fetch('https://pay-cert.dcap.com/v1/credit/sale', {
                method: 'POST',
                body: JSON.stringify(payApiRequest),
                headers: headers,
                })
                .then(function (payApiResponse) {
                    payApiResponse.json().then(function (json) {
                    if (payApiResponse?.status && payApiResponse?.status != 200) {
                        let errObject = {
                            payload: payApiRequest,
                            errorMessage: payApiResponse,
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.SALE_API_FAILURE} credit/sale`))
                        reject('Error' + json.Message)
                        setErrorMessage(`Error in Sale API: ${json?.Message ? json?.Message : errorMessage?.somethingWentWrong}`)
                        setIsPaymentLoading(false)
                        setPage(2)
                    } else {
                        let errObject = {
                            payload: payApiRequest,
                            errorMessage: payApiResponse,
                        }
                        dispatch(addEventLog(errObject, `${CONSTANTS?.SALE_API_SUCCESS} credit/sale`))
                        resolve('Approved' + json.Message)
                        const responseToSubmit = paymentData?.requestData
                        const request = JSON.parse(responseToSubmit?.request)
                        request.walletPay = json
                        request.transaction_id = json?.RefNo
                        responseToSubmit.request = request
                        setErrorMessage('')
                        // setResponseToSubmit(responseToSubmit)
                        submitResponseOnServer(responseToSubmit)
                    }
                    })
                })
                .catch((err) => {
                    let errObject = {
                        payload: payApiRequest,
                        errorMessage: err,
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.SALE_API_FAILURE} credit/sale`))
                    setErrorMessage(`Error is Sale API: ${err ? err : errorMessage?.somethingWentWrong}`)
                    notify('error', err ? err : errorMessage?.somethingWentWrong)
                })
                }
            }
          }).catch((err) => {
            let errObject = {
                payload: paymentData,
                errorMessage: err
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.UNEXPECTED_ERROR} tokenError tokenizeAPi-mobileGooglePayDC.js-185`))
          })
        }
        return tokenCallback
    }
    return (
        displayError ? <div className='main'>
            <div>
                <NoData message={failedMessage}/>
            </div>
        </div> : 
        <div className='main'>
                { page == 0 ?
                ispaymentLoading ? 
                    <div className='container'>
                        <div className=' d-flex justify-content-center p-2 border-grey border border-2 border-primary border-opacity-50 rounded'>
                        <p className='mb-0'>Please wait...</p> <span className='ms-2'><Circles
                                height="20"
                                width="20"
                                color='text-primary'
                                style={{ display: 'inline-block' }}
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                            </span>
                        </div>
                    </div>
                    :
                    <div className={ispaymentLoading ? 'd-none' : 'buttonWrapper container'}>
                        <div id='google-pay-button'></div>
                    </div>
                : null}
        </div>
    )
}
mobileGooglePayDC.propTypes = {
    dispatch: PropTypes.func,
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    onSubmit: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    setThankYouMessage: PropTypes.func, 
    setResponse: PropTypes.func,
    setPage: PropTypes.func,
    page: PropTypes.number,
    setErrorMessage: PropTypes.func,
    setDisplayError: PropTypes.func,
    failedMessage: PropTypes.string,
    displayError: PropTypes.string,
}

mobileGooglePayDC.defaulProps = {
    dispatch: noop,
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
    setThankYouMessage: noop, 
    setResponse: noop,
    setPage: noop,
    page: 0,
    setErrorMessage: noop,
    setDisplayError: noop,
    failedMessage: undefined,
    displayError: undefined,
}

function mapStateToProps() {
    return {
    }
}

export default connect(mapStateToProps)(mobileGooglePayDC)